import { ArrowRightIcon, Button } from '@catawiki/cata-style';
import { LangUri } from '@catawiki/runtime-toolkit';

import { useLocale } from '@/shared/hooks/useLocale';

type LearnMoreLinkProps = { className?: string; text: string; url: string };

export const LearnMoreLink = ({ className, text, url }: LearnMoreLinkProps) => {
  const { isoLocale } = useLocale();

  return (
    <Button
      className={className}
      as="a"
      variant="tertiary"
      icon={ArrowRightIcon}
      iconPosition="end"
      iconSize="xs"
      target="_blank"
      rel="noopener noreferrer"
      href={LangUri.generateLocalePath(isoLocale, url)}
    >
      {text}
    </Button>
  );
};
